import type { QualityRule } from '../types/requirement-quality.js'

/**
 * Requirement-level quality rules, inspired by ASPICE SWE.1 (requirement
 * attributes) and the INCOSE Guide to Writing Requirements (characteristics of
 * a well-formed requirement).
 *
 * Written in our own words: no guide text is quoted and items are not mapped to
 * rule numbers. Each rule is judged per requirement. DRAFT — needs review.
 */
export const QUALITY_RULES_VERSION = '2026-10-26-draft-1'

export const QUALITY_RULES: QualityRule[] = [
  {
    id: 'RQ-01',
    name: { ja: '識別子', en: 'Identifier' },
    check: {
      ja: '要求に一意の ID が付いており、他の要求から参照・追跡できる。',
      en: 'The requirement carries a unique id so it can be referenced and traced.',
    },
  },
  {
    id: 'RQ-02',
    name: { ja: '単一性', en: 'Singular' },
    check: {
      ja: '1 つの文が 1 つの要求だけを述べている（独立した複数の要求を「かつ」「および」等で束ねていない）。条件の列挙 (1)(2) は 1 つの要求として扱う。',
      en: 'One statement states one requirement (independent requirements are not bundled with "and" / "as well as"). An enumerated condition list (1)(2) counts as one requirement.',
    },
  },
  {
    id: 'RQ-03',
    name: { ja: '明確性', en: 'Unambiguous' },
    check: {
      ja: '解釈が分かれる曖昧な語（例：速やかに、適切に、十分な、なるべく、等、など、可能な限り）を使っていない。',
      en: 'No vague wording that allows several readings (e.g. quickly, appropriate, sufficient, as far as possible, etc.).',
    },
  },
  {
    id: 'RQ-04',
    name: { ja: '検証可能性', en: 'Verifiable' },
    check: {
      ja: '合否を判定できる受入基準（数値と単位、許容範囲、判定条件）が書かれている。',
      en: 'States acceptance criteria that allow a pass/fail decision (values with units, tolerances, decision conditions).',
    },
  },
  {
    id: 'RQ-05',
    name: { ja: '条件の明示', en: 'Conditions stated' },
    check: {
      ja: '主語（どの構成要素が）と、動作のきっかけ・前提条件（いつ、どの状態で）が明示されている。',
      en: 'States the subject (which component) and the trigger or precondition (when, in which state).',
    },
  },
  {
    id: 'RQ-06',
    name: { ja: '未決事項なし', en: 'No open items' },
    check: {
      ja: '「TBD」「TBC」「未定」などの未決のプレースホルダーが残っていない。',
      en: 'No open placeholders such as "TBD", "TBC" or "to be decided" remain.',
    },
  },
  {
    id: 'RQ-07',
    name: { ja: '用語の一貫性', en: 'Consistent terms' },
    check: {
      ja: '構成要素・信号・モードを仕様内の他の要求と同じ名前で呼んでいる。',
      en: 'Components, signals and modes are called by the same names as elsewhere in the spec.',
    },
  },
]

export const QUALITY_RULE_IDS = QUALITY_RULES.map(r => r.id)
